<template>
    <div id="analysis-one">
        <h2>{{title}}</h2>
        <p v-html="describe">{{describe}}</p>
        <el-button-group>
            <template v-if="noDisplay.indexOf('smoothLine') === -1">
                <el-button size="small" @click="handleChartChange('smoothLine')"><i class="iconfont ipiconlinechart" aria-hidden="true"></i> 曲线图</el-button>
            </template>
            <template v-if="noDisplay.indexOf('bar') === -1">
                <el-button size="small" @click="handleChartChange('bar')"><i class="iconfont ipiconbarchart" aria-hidden="true"></i> 柱状图</el-button>
            </template>
            <template v-if="noDisplay.indexOf('crossBar') === -1">
                <el-button size="small" @click="handleChartChange('crossBar')"><i class="iconfont ipiconcrossBar" aria-hidden="true"></i> 横向柱状图</el-button>
            </template>
            <template v-if="noDisplay.indexOf('brush') === -1">
                <el-button size="small" @click="handleChartChange('brush')"><i class="iconfont ipiconclassify" aria-hidden="true"></i> 色块图</el-button>
            </template>
            <template v-if="noDisplay.indexOf('radar') === -1">
                <el-button size="small" @click="handleChartChange('radar')"><i class="iconfont ipiconradar" aria-hidden="true"></i> 雷达图</el-button>
            </template>
            <template v-if="noDisplay.indexOf('bubble') === -1">
                <el-button size="small" @click="handleChartChange('bubble')"><i class="iconfont ipiconbubble" aria-hidden="true"></i> 气泡图</el-button>
            </template>
            <el-button size="small" @click="handleShowTable()"><i class="iconfont ipiconform" aria-hidden="true"></i> 表格</el-button>
            <slot name="button"></slot>  
            <el-button class="export" size="small" type="primary" @click="exportDateTable"><i class="iconfont ipiconform" aria-hidden="true"></i> 导出表格</el-button>  
            <el-button class="export" type="primary" size="small" @click="exportImage"><i class="iconfont ipiconpicture"></i> 导出图片</el-button>
        </el-button-group>
        <div v-if="chartData.length === 0" v-loading="innerLoading || loading" class="empty-chart">暂无数据</div>
        <div id="chart" v-show="!isShowTable" v-loading="innerLoading || loading"></div>
        <div v-show="isShowTable" class="table">
            <el-table :data="chartData"  style="width: 100%" height="520" id="export-table">
                  <el-table-column align="center" v-for="(index, key) of tableTitle" :label="index">
                    <template slot-scope="scope">
                        <template v-if="key >= 1 && +chartData[scope.$index][key] > 0">
                            <el-button @click="handleClickItem(chartData[scope.$index],key)" type="text" size="small">
                                {{chartData[scope.$index][key]}}
                            </el-button>
                        </template>
                        <template v-else>
                            {{chartData[scope.$index][key]}}
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import View from '@antv/data-set'
export default {
  name: 'ipAnalysisTwoDimension',
  props:{
        title:{type: String,default: ''},
        describe:{type:String,default:''},
        defaultChart:{
            type:String,
            default:'smoothLine',
            validator(value){
                if(value === 'smoothLine' || value === 'bar' || value === 'radar' || value === 'bubble' 
                || value === 'crossBar'|| value === 'brush'){
                    return true
                }else{
                    return false
            }
        }},
        chartData:{
            type:Array,
            default(){
                return []
            },
            required:true
        },
        tableTitle:{
            type:Array,
            default(){ 
                return ['名称','数量']
                },
            validator(value){
                return value.length >= 2
            }   
        },
        xIsRotate:{type:Boolean,default:false},
        alias:{type:Object,default(){
            return {x:'key',y:'value'}
        }},
        noDisplay:{type:Array,default(){
            return []
        }},
        loading:{type:Boolean,default:false}
  },
  data(){
      return{
        innerLoading:true,
        chart:{},
        isShowTable:false,
        dataSet:[]
      }
  },
  watch: {
        chartData(nv,ov) {
            this.dataSet = [];
            for (var i = 0; i < nv.length; i++) {
                var row = nv[i];
                var name = row[0];
                for (var j = 1; j < row.length; j++) {
                    var key = this.tableTitle[j];
                    this.dataSet.push({
                        name: name,
                        key: key,
                        value: +row[j],
                    });
                }
            }
            this.handleChartChange(this.defaultChart); 
        }
  },
  mounted(){
       const theme = G2.Util.deepMix({
                shape: {
                    interval: {
                        fillOpacity: 1 // 填充透明度设置
                    },
                    intervalStack:{
                        fillOpacity: 1 // 填充透明度设置
                    },
                    line:{
                        fillOpacity: 1 // 填充透明度设置
                    },
                    polygon:{
                        fillOpacity: 1 // 填充透明度设置
                    }
                },
                axis: {
                    top:{
                        label: {
                            textStyle: { fill: '#000'} // 右部标签文本的颜色
                        }
                    },
                    bottom: {
                        label: {
                            rotate: this.xIsRotate ? -Math.PI / 6 : 0,
                            textStyle:{
                                fill: '#000',
                                textAlign: this.xIsRotate ? 'end' : 'center',
                                textBaseline: 'middle',
                            }
                        },
                        title:{
                            textStyle: {
                                fill: '#000', // 文本的颜色
                            },
                            position:'end'
                        }
                    },
                    left: {
                        label: {
                            autoRotate:false,
                            textStyle: {
                                fill: '#000',
                                rotate:0
                            } // 左部标签文本的颜色
                        },
                        title:{
                            textStyle: {
                                fill: '#000', // 文本的颜色
                            },
                            position:'end'
                        }
                    },
                    right: {
                        label: {
                            textStyle: { fill: '#000'} // 右部标签文本的颜色
                        }
                    },
                    radius:{
                        label:{
                            textStyle: { fill: '#000'} 
                        }
                    },
                    circle:{
                        label: {
                            textStyle: { fill: '#000'} // 右部标签文本的颜色
                        }
                    }
                },
            label: {
                textStyle: {
                        fill: '#000',
                }
            },
            legend:{
                bottom: {
                    textStyle: {
                        fill: '#000',// 底部标签文本的颜色
                    }
                },
                left: {
                    textStyle: {
                        fill: '#000',// 底部标签文本的颜色
                    }
                },
                right: {
                    textStyle: {
                        fill: '#000',// 底部标签文本的颜色
                    }
                }
            },
            tooltip: {
                'g2-tooltip':{
                    color: 'rgb(0, 0, 0)',
                }
            }
        }, G2.Theme);

        G2.Global.setTheme(theme);
        this.chart = new G2.Chart({
                container: 'chart',
                forceFit: true,
                height: 520,
                padding:['auto',20,'auto','auto']
            });
        this.handleChartChange(this.defaultChart);
  },
  methods:{
        handleChartChange(type){
            this.isShowTable = false;
            switch (type) {
                case 'smoothLine':
                    this.smoothLineChart()
                    break;
                case 'bar':
                    this.barChart()
                    break;
                case 'radar':
                    this.radarChart()
                    break;
                case 'bubble':
                    this.bubbleChart()
                    break;
                case 'crossBar':
                    this.crossBarChart();
                    break;
                case 'brush':
                    this.brushChart();
                    break;
            }
        },
        handleShowTable(){
            this.isShowTable = true;
        },
        exportDateTable () {
            this.$emit('export-table','export-table');
        },
        exportImage(){
            let self = this;
            setTimeout(function() {
                self.chart.downloadImage(self.title);
            }, 1500);
        },
        handleClickItem(row,index){
            this.$emit('table-click',row[0],this.tableTitle[index]);
        },
        // 色块图
        brushChart(){
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.dataSet);
            this.chart.scale({
                key:{
                    alias: this.alias['x'],
                },
                value:{
                    alias:this.alias['y']
                }
            });
            this.chart.axis('key', {
                tickLine: null,
                grid: {
                align: 'center',
                lineStyle: {
                    lineWidth: 1,
                    lineDash: null,
                    stroke: '#f0f0f0'
                 }
                }
            });
            this.chart.axis('name', {
                 title:null});
            this.chart.axis('value', {
                tickLine: null,
                grid: {
                align: 'center',
                lineStyle: {
                    lineWidth: 1,
                    lineDash: null,
                    stroke: '#f0f0f0'
                },
                showFirstLine: true
                }
            });
            this.chart.legend(false);
            this.chart.polygon().position('key*name').color('value', '#BAE7FF-#1890FF-#0050B3').label('value', {
                offset: -2,
                textStyle: {
                fill: '#fff',
                shadowBlur: 2,
                shadowColor: 'rgba(0, 0, 0, .45)'
                }
            }).style({
                lineWidth: 1,
                stroke: '#fff'
            });
            this.chart.render();
            this.chart.interact('brush', {
                style: {
                    lineWidth: 1,
                    stroke: '#999',
                    fill: '#999',
                    fillOpacity: 0.3
                },
            onBrushmove: function onBrushmove() {
                this.chart.hideTooltip();
                }
            });
            this.innerLoading = false;
        },
        // 雷达图
        radarChart(){
            this.chart.clear().source(this.chartData).coord('polar');
            this.chart.source(this.dataSet);
            this.chart.coord('polar', {
                radius: 0.8
            });
            this.chart.line().position('key*value').color('name').size(2);
            this.chart.point().position('key*value').color('name').shape('circle').size(4).style({
                stroke: '#fff',
                lineWidth: 1,
                fillOpacity: 1
            });
            this.chart.area().position('key*value').color('name');
            this.chart.render();
            this.innerLoading = false;
        },
        // 曲线图
        smoothLineChart(){
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.dataSet,{
                'key': {
                    range: [0, 1]
                }
            });
            this.chart.scale({
                key:{
                    alias: this.alias['x'],
                },
                value:{
                    alias:this.alias['y']
                }
            });
            this.chart.axis('key',{
                label:{
                    autoRotate:false,
                    textStyle:{
                        rotate: this.xIsRotate ?-Math.PI/6 :0,
                        textAlign: 'end',
                        textBaseline: 'middle',
                    }
                }
            });
            this.chart.legend(true);
            this.chart.line().position('key*value').color('name').shape('smooth');
            this.chart.point().position('key*value').color('name').size(4).shape('circle').style({
                stroke: '#fff',
                lineWidth: 1
            });
            this.chart.render();
            this.innerLoading = false;
        },
        // 柱状图
        barChart(){
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.dataSet);
            this.chart.scale({
                key:{
                    alias: this.alias['x'],
                    type:'cat'
                },
                value:{
                    alias:this.alias['y'],
                }
            });
            this.chart.axis('key',{
                label:{
                    autoRotate:false,
                    textStyle:{
                        rotate: this.xIsRotate ?-Math.PI/6 :0,
                        textAlign: 'end',
                        textBaseline: 'middle',
                    }
                }
            });
            this.chart.interval().position('key*value').color('name').adjust([{
                type: 'dodge',
                marginRatio: 1 / 32
            }]);
            this.chart.render();
            this.innerLoading = false;
        },
        crossBarChart(){
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.dataSet);
            this.chart.scale({
                key:{
                    alias: this.alias['x'],
                    type:'cat'
                },
                value:{
                    alias:this.alias['y'],
                }
            });
            this.chart.axis('key',{
                label:{
                    textStyle:{
                        autoRotate:false,
                        rotate:0
                    }
                },
                title:false
            })
            this.chart.interval().position('key*value').color('name').adjust([{
                type: 'dodge',
                marginRatio: 1 / 32
            }]);
            this.chart.coord().transpose();
            this.chart.render();
            this.innerLoading = false;
        },
        bubbleChart(){
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.legend('value', false);
            this.chart.axis('key',{
                label:{
                    autoRotate:false,
                    textStyle:{
                        rotate: -Math.PI/6,
                        textAlign: 'end',
                        textBaseline: 'middle',
                    }
                }
            });
            this.chart.scale({
                key:{
                    alias: this.alias['x'],
                },
                value:{
                    alias:this.alias['y']
                }
            });
            this.chart.source(this.dataSet);
            this.chart.point().position('key*value').size('value', [8, 65]).color('name').shape('circle').tooltip('Country*Population*GDP*LifeExpectancy').style('continent', {
                lineWidth: 1,
                strokeOpacity: 1,
                fillOpacity: 1,
                opacity:1
            }).tooltip('name*value*key', function(name, value, key) {
                return {
                    key: key ,
                    name: name ,
                    value: value
                };
            });
            this.chart.render();
            this.innerLoading = false;
        }
  }
}
</script>

<style lang="scss" scoped>
#analysis-one{
    color: #333;
    position: relative;
    .empty-chart{
        width: 100%;
        height: 500px;
        position: absolute;
        z-index: 900;
        background: #ffffff;
        font-size: $sm-font-size;
        color: #4d4d4d;
        text-align: center;
        padding-top: 35px;
    }
    h2{
        font-size: $lg-font-size;
        margin-bottom:10px;
        font-weight: normal;
    }
    p{
        margin: 10px 0 15px 0;
        line-height: 20px;
        font-size: $sm-font-size;
    }
    .export{
        margin-left: 20px;
    }
    #chart{
        margin-top: 20px;
        height: 520px;
    }
    .link{
        color: $theme-color;
        cursor: pointer;
    }
    .table{
        margin-top: 20px;
    }
}
</style>
<style lang="scss">
#analysis-one{
    .el-table{
        color: #333;
        th{
            background:#EFF2F6;
            color: #333;
            font-weight: normal;
            // font-size: $md-font-size;
            padding: 6px 0;
        }
    }
}
</style>

